<template>
  <div
    class="flex gap-4"
    :class="vertical ? 'flex-row md:flex-col' : 'flex-row'"
  >
    <div
      v-for="item in socialMedia"
      :key="item"
      class="cursor-pointer"
      @click.prevent="shareContent(item)"
    >
      <NuxtIcon :name="item.name" filled class="share-icon" />
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  socialMedia: {
    type: Array,
    default: () => []
  },
  vertical: {
    type: Boolean,
    default: true
  }
})

const shareContent = data => {
  const url = data.url.replace(/@u/g, encodeURIComponent(data.url))
  const windowSizing = 'left=100,top=100,width=600,height=500'

  if (data.name === 'linkedin') {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?u=${url}`,
      'newwindow',
      windowSizing
    )
  } else if (data.name === 'whatsapp') {
    window.open(
      `https://api.whatsapp.com/send?text=${url}`,
      'newwindow',
      windowSizing
    )
  }
}
</script>

<style lang="scss" scoped></style>
